import localeEn from '@/app/pharmacy/locales/en'
import localeAr from '@/app/pharmacy/locales/ar'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
//import { noRecordTemplate, getTooltipTilte, showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import { noRecordTemplate, showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import kendo from '@progress/kendo-ui';
import $ from 'jquery';
import Loader from '@/app/shared/layouts/components/loader/loader.vue';
import { isValueInDataSource } from '@/app/shared/dropdowns-functionality/combobox.js';
import { getAttachTypeEnums, getAttachmentSaveResult, getArabicSupportEnum } from '@/app/pharmacy/shared/pharmacy-enums.js';
import { Upload, UploadInstaller } from '@progress/kendo-upload-vue-wrapper';
import { visitService } from '@/app/pharmacy/shared/services/visit-service';
import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { EventBus } from '@/app/shared/services/event-bus.js';

Vue.use(UploadInstaller)
import Vue from 'vue'

import ConfirmDeletePopup from './delete-popup/delete-popup.vue';

import InAssginConfirmDeletePopup from './inassgin-popup/inassgin-popup.vue';
import AssginConfirmDeletePopup from './assgin-popup/assgin-popup.vue';


export default {

    data() {
        return {
            userIdAttchm:null,
            imageUrl: null,
            fileReaderForPrint: new FileReader(),
            pageNameURL: "",
            isLoading: false,
            hideNotification: 5000,

            PharmacyAddAttachmentPermission: this.showHideElement("PharmacyAddAttachment"),
            PharmacyAssignAttachmentPermission: this.showHideElement("PharmacyAssignPatientAttachmentToVisit"),
            PharmacyInAssignAttachmentPermission: this.showHideElement("PharmacyInAssignPatientAttachmentToVisit"),
            PharmacyDeleteAttachmentPermission: this.showHideElement("PharmacyDeleteAttachments"),
            PharmacyPrintAttachmentPermission: this.showHideElement("PharmacyPrintAttachment"),
            PharmacyViewAttachmentPermission: this.showHideElement("PharmacyViewAttachment"),
            isArabicLanguage: localStorage.getItem('NG_TRANSLATE_LANG_KEY') !== 'en',
            currentLanguage: localStorage.getItem('NG_TRANSLATE_LANG_KEY'),
            requiredFile: false,
            UploadType: getAttachTypeEnums().Upload,
            ScanType: getAttachTypeEnums().Scan,
            AttachmentCategoryDataSource: true,
            isDuplicatedAttachmentTitle: false,
            ScannersAvaliablesDataSource: true,
            VisitAttachmentParameters: {},
            AssignParameters: {},
            MaxFileSize: null,
            counter: 0,
            fileValid: true,
            appearProgress: false,
            disabledImport: true,
            FileReader: null,
            isAssigned: false,
            showPageNameIframe: false,
            AttachmentCategoryDS: [

            ],
            ScannersAvaliablesDS: { data: [] },

            formData: {
                AttachType: this.UploadType,
                AttachmentCategoryID: null,
                AttachmentTitle: "",
                ScannersAvaliablesID: null,
                uploadVisitChecked: true,
                nameFile: '',

            },
            AttachmentsObj: {
                VisitId: null,
                PatientID: null,
                AttachmentTitle: null,
                AttachmentCategoryID: null,
                AttachmentScanLoad: null,
                AttachmentPath: null,
                IsUniqueTitle: true,
                IsValidAttachmentFileType: true,
                IsValidAttachmentFileSize: true,
                AttachmentFileError: null,
                files: [],
                AssignAttachToVisit: true,
                isVisitAttachement: false,
                ModuleID: null,
                OrderLineID: null,
            }
            ,
            attachmentDS: {},
            pageable: {
                pageSizes: [5, 10, 20, 50, 100],
                buttonCount: 5,
                pageSize: 10
            },
            PatientAttachCommand: [
                //
                {
                    name: 'assignRow',
                    click: this.assignRow,
                    text: this.$i18n.t('Pharmacy.assign'),
                    template: `<a role='button' class='k-button k-button-icontext k-grid-assignRow mr-1 ml-1'> ${this.$i18n.t('Pharmacy.assignBtn')}<img src=${require('@/assets/svg/assign.svg')} /></a>`
                },
                {
                    name: "printAttachmentRow",
                    click: this.PrintPatientAttachment,
                    text: this.$i18n.t('Pharmacy.Print'),
                    template: `<a role="button" class='k-grid-printAttachmentRow k-button k-button-icontext k-grid-printattachmentrow'> ${this.$i18n.t('Pharmacy.Print')}<img src=${require('@/assets/svg/print.svg')} /></a>`
                },
                {
                    name: "deletePatientAttach",
                    text: this.$i18n.t('Common.Delete'),
                    //iconClass: 'fas fa-trash-alt',
                    click: this.deletePatientAttach,
                    template: `<a role="button" class='k-grid-deletePatientAttach k-button k-button-icontext k-grid-deleterow mr-1 ml-1'>${this.$i18n.t('Common.Delete')} <img src=${require('@/assets/svg/ic_delete.svg')} /></a>`
                    
                       
                },
                {
                    name: "view",
                    text: this.$i18n.t('Pharmacy.View'),
                    click: this.clickViewPatientAttach,
                    template: `<a role='button' class='k-button k-button-icontext  k-grid-view custom-view' > ${this.$i18n.t('Pharmacy.View')} <img src=${require('@/assets/svg/ViewIcon.svg')} /></a>`
                }
            ],
            VisitAttachCommand: [
                {
                    name: 'unassignRow',
                    click: this.unassignRow,
                    text: this.$i18n.t('Pharmacy.unassign'),
                    template: `<a role='button' class='k-button k-button-icontext k-grid-unassignRow mr-1 ml-1 '> ${this.$i18n.t('Pharmacy.INssignBtn')}<img src=${require('@/assets/svg/unassign.svg')} /></a>`
                },
                {
                    name: "printAttachmentRow",
                    click: this.PrintVisitAttachment,
                    text: this.$i18n.t('Pharmacy.Print'),
                    template: `<a role="button" class='k-grid-printAttachmentRow k-button k-button-icontext k-grid-printattachmentrow'> ${this.$i18n.t('Pharmacy.Print')}<img src=${require('@/assets/svg/print.svg')} /></a>`
                },
                {
                    name: "view",
                    text: this.$i18n.t('Pharmacy.View'),
                    click: this.ViewVisitAttach,
                    template: `<a role='button' class='k-button k-button-icontext  k-grid-view custom-view' > ${this.$i18n.t('Pharmacy.View')} <img src=${require('@/assets/svg/ViewIcon.svg')} /></a>`
                }
            ],
        }
    },


    methods: {
        PrintPatientAttachment(e) {
            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);

            //     let grid = $("#PatientAttachGrid").getKendoGrid();
            // if (grid != undefined) {
            //     let item = grid.dataItem(e.target.closest("tr"));

            this.PrintAttachment(this.attachmentDS.data[indexParent]);
            //   }
        },
        PrintVisitAttachment(e) {
            //   let grid = $("#VisitAttachGridView").getKendoGrid();
            //   if (grid != undefined) {
            //      let item = grid.dataItem(e.target.closest("tr"));
            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);
            this.PrintAttachment(this.attachmentDS.data[indexParent]);
            //   }
        },
        showHideElement(clientAction) {
            return modelServices.ifUserHasPermission(clientAction, this.$route.name);
        },
        initAttachmentModal() {
            debugger
            this.isLoading = true;
            console.log("this.AttachmentsObj", this.AttachmentsObj)
            console.log("this.$route.path", this.$route.path)
           
         
            var params = {
                 VisitID: this.VisitAttachmentParameters.VisitId,
              //  VisitID: localStorage.getItem('visitId'),
               // VisitID: sessionStorage.getItem("sessionVisitID"),
                PatientID: this.VisitAttachmentParameters.PatientID,                
                moduleID: this.AttachmentsObj.ModuleID,
                orderLineID: this.AttachmentsObj.OrderLineID,
                isVisitAttachement: this.AttachmentsObj.isVisitAttachement,
            };
            console.log("params", params)

            visitService.InitOpenAttachmentPopup(params, response => this.bindAttachments(response), err => {
                this.isLoading = false;
                
                //this.userIdAttchm = response.LoggedInUserID
                console.log(err);
            });
        },
        validateAttachmentTitle() {
            var AttachmentTitlePattern;
            if (this.isArabicLanguage) {
                AttachmentTitlePattern = /[\u0600-\u06FF]/;
            }
            else {
                AttachmentTitlePattern = /^[A-Za-z0-9 _-]*$/;
            }
            if (this.AttachmentsObj.AttachmentTitle) {
                if (!AttachmentTitlePattern.test(this.AttachmentsObj.AttachmentTitle)) {
                    if (AttachmentTitlePattern.test(this.AttachmentsObj.AttachmentTitle.substring(0, this.AttachmentsObj.AttachmentTitle.length - 1))) {
                        this.AttachmentsObj.AttachmentTitle = this.AttachmentsObj.AttachmentTitle.substring(0, this.AttachmentsObj.AttachmentTitle.length - 1)
                    }
                    else {
                        this.validateAttachmentTitleOnPaste();
                    }
                }
                else {
                    this.resetTitleUniquenessIndicator();
                }
            }
        },
        resetTitleUniquenessIndicator() {
            this.AttachmentsObj.IsUniqueTitle = true;
        }
        ,
        validateAttachmentTitleOnPaste() {
            if (this.AttachmentsObj.AttachmentTitle) {
                this.AttachmentsObj.AttachmentTitle = this.AttachmentsObj.AttachmentTitle.replace(/[^\w\s-_]/gi, '');
            }
        },
        FormateArabicDate(date) {
            date = date.replace(new RegExp(getArabicSupportEnum().AM_En, 'g'), getArabicSupportEnum().AM_Ar)
                .replace(new RegExp(getArabicSupportEnum().PM_En, 'g'), getArabicSupportEnum().PM_Ar);
            return date;
        },
        FormateArabicTime(time) {
            time = time.replace(new RegExp(getArabicSupportEnum().Hourse_En, 'g'), getArabicSupportEnum().Hourse_Ar)
                .replace(new RegExp(getArabicSupportEnum().Hourse_En, 'g'), getArabicSupportEnum().Hourse_En);
            time = time.replace(new RegExp(getArabicSupportEnum().Minute_En, 'g'), getArabicSupportEnum().Minute_Ar)
                .replace(new RegExp(getArabicSupportEnum().Minute_En, 'g'), getArabicSupportEnum().Minute_En);
            return time;
        }
        ,
        bindAttachments(response) {
            this.isLoading = false;
            if (response) {
                this.userIdAttchm =   response.data.LoggedInUserID
               
                if (response.data) {
                    if (this.VisitAttachmentParameters.isViewOnly) {
                        $(".PatientAttachments-tab").removeClass("k-state-active");
                        $(".VisitAttachments-tab").addClass("k-state-active")

                        $(".PatientAttachments").css("display", "none");
                        $(".VisitAttachments").css("display", "block");
                    }
                    var result = response.data;
                    //************* fill Attachment Category DDL *********************
                    this.AttachmentCategoryDS = new kendo.data.HierarchicalDataSource({
                        data: result.VisitAttachementType
                    });




                    this.attachmentDS = { data: result.VisitAttachmentsDocument };
                    //************* configuration *********************
                    this.MaxFileSize = result.MaxFileSize;

                    //************* Scanner Initialize *********************

                    if (!this.ScannerServiceUrl) {
                        this.initScannerObjects();

                        this.ScannerServiceUrl = result.ScannerServiceUrl;

                        this.ScannerServiceInitialization();
                    }
                }
            } else {
                this.$refs['attachement-ref'].hide();
            }
        },
        initScannerObjects() {
            this.ScannerServiceUrl = "";
            this.SelectedScanner = "";
            this.ScannersAvaliablesDS.data = [];
            this.IsScannedFile = () => this.AttachType == 2;
            window.ws = null;
            this.FileReader = null;
        },
        ScannerServiceInitialization() {
            var wsImpl = window.WebSocket || window.MozWebSocket;
            if (!window.ws) {
                window.ws = new wsImpl(this.ScannerServiceUrl);
                window.ws.onmessage = (e) => {
                    if (typeof e.data === "string") {
                        //IF Received Data is String             

                        setTimeout(() => {
                            var scanners = e.data.split(',');

                            this.MapToScannerModel(scanners);
                        }, 1);



                    }
                    else if (e.data instanceof ArrayBuffer) {
                        //IF Received Data is ArrayBuffer
                    }
                    else if (e.data instanceof Blob) {
                        var scannedFileData = e.data;


                        this.FileReader = new FileReader();

                        this.FileReader.onload = async (e) => {
                            var scannedFile = this.formatFile(e.target.result, 'scan.jpg');
                            this.AttachmentsObj.IsScannedFile = true;
                            this.AttachmentsObj.files = [scannedFile];
                            this.isLoading = true;
                            await this.Savefiles();
                        }


                        this.FileReader.readAsDataURL(scannedFileData);
                    }
                };

                window.ws.onopen = () => {
                    setTimeout(() => {
                        this.GetScanners();

                    });

                };
                window.ws.onclose = function () {
                    console.log('Scanner', 'Scanner Service Connection Closed');
                };
            }
        },

        GetScanners() {
            if (window.ws.readyState == WebSocket.OPEN) {
                window.ws.send("GetScanners");
            }
        },

        MapToScannerModel(scannersArr) {
            this.ScannersAvaliablesDS.data = [];
            for (var i = 0; i < scannersArr.length; i++) {
                this.ScannersAvaliablesDS.data.push({ Name: scannersArr[i] });
            }
        },



        showPopupNotification,
        ViewVisitAttach(e) {
            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);
            console.log("indexParent", indexParent)
            this.ViewAttachment(this.attachmentDS.data[indexParent]);
        },
        printPatientAttach(e) {
            let grid = $("#PatientAttachGrid").getKendoGrid();
            if (grid != undefined) {
                let item = grid.dataItem(e.target.closest("tr"));
                this.PrintAttachment(item);
            }
        },
        clickViewPatientAttach(e) {
    
            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);
            console.log("indexParent", indexParent)
            this.ViewAttachment(this.attachmentDS.data[indexParent]);
            //let grid = $("#PatientAttachGrid").getKendoGrid();
            // debugger
            //if (grid != undefined) {
            //    let item = grid.dataItem(e.target.closest("tr"));
            //    console.log("item", item)
            //    this.ViewAttachment(item);
            //}
        },
        formatFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, { type: mime });
        },
        OpenAttachmentPrintDialog(blob) {
            var vm = this;
            this.fileReaderForPrint.onload = function (e) {
                vm.imageUrl = e.target.result;
                vm.printAttachment();
            };

            this.fileReaderForPrint.readAsDataURL(blob)
        },
        DownloadFileToPC(url, attachmentTitle) {
            var linkElement = document.createElement('a');
            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", attachmentTitle);

            var clickEvent = new MouseEvent("click", {
                "view": window,
                "bubbles": true,
                "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);
        },
        OpenAttachmentViewer(url, attachmentTitle) {
           
            console.log('url', attachmentTitle)
            $("#Attachmentkendowindowid").kendoWindow({
                content: url,
                iframe: true,
                modal: true,
                title: attachmentTitle,
                visible: false,
                draggable: false,
                resizable: false,
                open: function () {
                  
                    $("body").addClass("fitAttachmentPreviewModal");
                    // $(e.sender.element).siblings(".k-header").find(".k-window-title").html(attachmentTitle);
                },
                close: function () {
                    $("body").removeClass("fitAttachmentPreviewModal");
                    console.log("sss", $("#Attachmentkendowindowid").parent());

                    $(".k-widget.k-window").addClass("d-none");
                    $(".k-overlay").addClass("d-none");

                },
                refresh: function (e) {
                    $(".k-widget.k-window").removeClass("d-none");

                    $("body").addClass("fitAttachmentPreviewModal");
                    $(e.sender.element).siblings(".k-header").find(".k-window-title").html(attachmentTitle);
                    var modalStyle = "<style type='text/css'>"
                        + "img {max-width:100%; max-height:100%;background-color:white;box-shadow: 2px 2px 2px #323639;}"
                        + "body {text-align: center!important;}";
                    modalStyle += "</style>";
                    $('iframe').contents().find("head").append($(modalStyle));
                }
            });


            $("#Attachmentkendowindowid").kendoWindow();
            var dialog = $("#Attachmentkendowindowid").data("kendoWindow");


            console.log("dialog", dialog)
            dialog.open();
        },
        ViewAttachment(item) {

            let vm = this;
            visitService.PharmacyDownloadAttachment(item.AttachmentID,
                data => {
                    if (data) {
                        try {
                             
                            var attachmentTitle = item.AttachmentTitle;
                            var headers = data.headers;
                            var isNotFound = headers['x-fileisnotfound']
                            var contentType = headers['content-type'];

                            if (isNotFound != "True") {
                                var blob = new Blob([data.data], {
                                    type: contentType
                                });

                                var url = window.URL.createObjectURL(blob);

                                if (contentType == 'application/pdf' || contentType == 'image/png' || contentType == "image/jpeg" || contentType == "image/jpg") {

                                    vm.OpenAttachmentViewer(url, attachmentTitle);

                                } else {
                                    vm.DownloadFileToPC(url, attachmentTitle);
                                }
                            }
                            else {
                                vm.showPopupNotification(`${vm.$i18n.t('Common.Failure')}`, `${vm.$i18n.t('Pharmacy.FileNotFound')}`, `error`);

                                vm.initAttachmentModal();
                            }
                        } catch (ex) {
                            vm.showPopupNotification(`${vm.$i18n.t('Common.Failure')}`, `${vm.$i18n.t('Pharmacy.Failure')}`, `error`);
                        }
                    } else {
                        this.$refs['attachement-ref'].hide();
                    }
                }
            )
        },
        PrintAttachment(item) {
            let vm = this;
            visitService.PharmacyDownloadAttachmentForPrint(item.AttachmentID,
                data => {
                    if (data) {
                        try {
                            var attachmentTitle = item.AttachmentTitle;
                            var headers = data.headers;
                            var isNotFound = headers['x-fileisnotfound']
                            var contentType = headers['content-type'];

                            if (isNotFound != "True") {

                                var blob = new Blob([data.data], {
                                    type: contentType
                                });

                                var url = window.URL.createObjectURL(blob);

                                if (contentType == 'application/pdf') {

                                    vm.OpenAttachmentViewer(url, attachmentTitle);

                                }
                                else if (contentType == 'image/png' || contentType == "image/jpeg" || contentType == "image/jpg") {

                                    vm.OpenAttachmentPrintDialog(blob);
                                }
                                else {

                                    vm.DownloadFileToPC(url, attachmentTitle);
                                }
                            }
                            else {
                                vm.showPopupNotification(`${vm.$i18n.t('Common.Failure')}`, `${vm.$i18n.t('Pharmacy.FileNotFound')}`, `error`);
                                vm.initAttachmentModal();
                            }
                        } catch (ex) {
                            vm.showPopupNotification(`${vm.$i18n.t('Common.Failure')}`, `${vm.$i18n.t('Pharmacy.Failure')}`, `error`);
                        }
                    } else {
                        this.$refs['attachement-ref'].hide();
                    }
                }
            )
        },

        assignRow(e) {
            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);

            console.log("selectedID", selectedID)
            console.log("indexParent", indexParent)

            // let grid = $('#PatientAttachGrid').data('kendoGrid');
            // let dataItem = grid.dataItem(e.target.closest("tr"));
            // console.log("grid",grid)
            // console.log("dataItem",dataItem)

            this.AssignParameters = { AttachmentID: this.attachmentDS.data[indexParent].AttachmentID, VisitID: this.VisitAttachmentParameters.VisitId, moduleID: this.VisitAttachmentParameters.module };
            EventBus.$emit('InAssignParameters', this.AssignParameters);
            this._bv__modal.show('AssigndeleteConfirmPopup-modal-scoped');
        },

        async Savefiles() {
            if ($(".k-file-validation-message").length > 0) {
                this.fileValid = false;
            } else {
                this.fileValid = true;

            }
            if (this.formData.nameFile) this.requiredFile = false;
            else this.requiredFile = true;
            const isValid = await this.$refs.observer.validate();
            if (isValid && this.AttachmentCategoryDataSource && this.AttachmentsObj.IsValidAttachmentFileSize &&
                this.AttachmentsObj.IsValidAttachmentFileType && this.AttachmentsObj.IsUniqueTitle) {
                this.isLoading = true;
                this.AttachmentsObj.VisitId = this.VisitAttachmentParameters.VisitId
                visitService.Savefiles(this.AttachmentsObj, this.AttachmentsObj.files[0], (response) => {
                    if (response) {
                        //this.initAttachmentModal();

                        switch (response.data) {
                            case getAttachmentSaveResult().Success:
                                this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('Pharmacy.SuccessfullyUploaded')}`, `success`);
                                this.clear();
                                this.initAttachmentModal();
                                break;
                            case getAttachmentSaveResult().InvalidAttachmentFileSize:
                                this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Pharmacy.FailedToUpload')}`, `error`);

                                this.AttachmentsObj.IsValidAttachmentFileSize = false;
                                this.initAttachmentModal();
                                break;
                            case getAttachmentSaveResult().InvalidAttachmentFileType:
                                this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Pharmacy.FailedToUpload')}`, `error`);

                                this.AttachmentsObj.IsValidAttachmentFileType = false;
                                this.initAttachmentModal();
                                break;
                            case getAttachmentSaveResult().InvalidAttachmentFileName:
                                this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Pharmacy.FailedToUpload')}`, `error`);
                                this.AttachmentsObj.IsUniqueTitle = false;
                                this.initAttachmentModal();
                                break;
                            case getAttachmentSaveResult().Failure:
                                this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Pharmacy.FailedToUpload')}`, `error`);
                                this.initAttachmentModal();
                                break;
                        }
                    }
                    else {
                        this.$refs['attachement-ref'].hide();
                    }
                }, err => { console.log(err); this.isLoading = false; });
            }

        },
        unassignRow(e) {

            // let grid = $('#VisitAttachGridView').data('kendoGrid');
            // let dataItem = grid.dataItem(e.target.closest("tr"));

            //  var grid = $("#VisitAttachGridView").data("kendoGrid");
            //  let dataItem = grid.dataItem(e.currentTarget.closest("tr"))

            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);
            

            // console.log("dataItem",dataItem)
            console.log("indexParent", this.attachmentDS.data[indexParent])

            this.AssignParameters = { AttachmentID: this.attachmentDS.data[indexParent].PatientAttachmentID, VisitID: this.VisitAttachmentParameters.VisitId };
            EventBus.$emit('InAssignParameters', this.AssignParameters);
            this._bv__modal.show('InAssigndeleteConfirmPopup-modal-scoped');
        },
        deletePatientAttach(e) {
          
           // let grid = $('#PatientAttachGrid').data('kendoGrid');
           // let dataItem = grid.dataItem(e.target.closest("tr"));

            let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
            let indexParent = this.attachmentDS.data
                .map(function (x) {
                    return x.AttachmentID;
                })
                .indexOf(selectedID);
         
            if (this.attachmentDS.data[indexParent].CreatedBy == this.userIdAttchm) {
                //let selectedID = $(e.currentTarget).closest("tr").find(".AttachmentID").data("parent_id");
                //let indexParent = this.attachmentDS.data
                //    .map(function (x) {
                //        return x.AttachmentID;
                //    })
                //    .indexOf(selectedID);

                this.AssignParameters = { AttachmentID: this.attachmentDS.data[indexParent].AttachmentID, ModifiedTS: this.attachmentDS.data[indexParent].ModifiedTS, IsAssignedToAnyVisit: this.attachmentDS.data[indexParent].IsAssignedToAnyVisit };
                EventBus.$emit('InAssignParameters', this.AssignParameters);
                this._bv__modal.show('deleteConfirmPopup-modal-scoped');
            }
          
        },
        printAttachment() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    const htmlData = this.$refs.printAttach;

                    const newWin = window.open();
                    newWin.document.write(`<!DOCTYPE html>
                        <html><head>
            <style type="text/css">
                        @page {
                                   margin: 3px;
                                }

                        @media print {
                                    html, body {
                                    margin: 3px 3px 3px 3px !important;
                                    padding: 0;
                                    width: 180mm;
                                    }

                                 </style></head>
                        <body> ${htmlData.innerHTML} </body></html>`);
                    newWin.document.close();
                    newWin.print();
                    setTimeout(() => {
                        newWin.close();
                    }, 100)
                });
            });

        },
        onSelectTab: function (e) {
            this.AttachmentsObj.isVisitAttachement = !this.AttachmentsObj.isVisitAttachement;
            if (this.AttachmentsObj.isVisitAttachement) {
                this.AttachmentsObj.UploadCurrentVisitToo = true;
            }
            this.initAttachmentModal();
            if (e.contentElement._prevClass == "VisitAttachments") {
              
                $('.uploadVisit-checkbox').addClass('d-none');
            } else {
                $('.uploadVisit-checkbox').removeClass('d-none');
            }
        },
        collapseForm: function () {
            $(".first-section").toggle();
            $(".icon").toggleClass("iconDown")

        },
        isValueInDataSource: e => isValueInDataSource(e),
        checkValidation(val, validatorName) {
            if (!val) {
                this.$refs.observer.errors[validatorName].push(this.$i18n.t("Common.Required"));
            } else {
                if (this.$refs.observer.errors[validatorName].length > 0) {
                    this.$refs.observer.errors[validatorName].shift();
                }
            }
        },

        //controls actions
        changeAttachmentCategory(e) {
            this.AttachmentsObj.AttachmentCategoryID = e.sender.element[0].value;
            if (e.sender.element[0].value != "") {
                this.AttachmentCategoryDataSource = this.isValueInDataSource(e);
            }
            else {
                this.AttachmentCategoryDataSource = true
            }

        },

        changeScannersAvaliables(e) {
            this.formData.ScannersAvaliablesID = e.sender.element[0].value;
            if (e.sender.element[0].value != "") {
                this.ScannersAvaliablesDataSource = this.isValueInDataSource(e);
            }
            else {
                this.ScannersAvaliablesDataSource = true
            }

        },
        onRemove() {
            $('.hint').removeClass('d-none');
            this.disabledImport = true;
            $("#FilesToUpload").prop("disabled", false);
            $("#FilesToUpload").parent().removeClass("disabledStyle");
            this.formData.nameFile = "";
debugger
            if (this.formData.nameFile) this.requiredFile = false;
            else {
                this.requiredFile = true;
                $("#FilesToUpload").show();
                $(".k-button.k-upload-button").removeClass("d-none");
                $(".UploadAttachmentPh img").show();
            }
        },

        changeLabelUpload() {
            $("#FilesToUpload").closest(".k-upload").find("span").text(`${this.$i18n.t('Common.UploadFile')}`);

        },
        onSelect(e) {
            // $('.hint').addClass('d-none');
            this.$emit(`onSelect`, e);
            this.disabledImport = false;
            $("#FilesToUpload").prop("disabled", true);
            $("#FilesToUpload").parent().addClass("disabledStyle")
debugger
            if (e.files[0]) {
                this.AttachmentsObj.files = [e.files[0].rawFile];
                this.formData.nameFile = e.files[0].name;
                if (this.formData.nameFile) this.requiredFile = false;
                else this.requiredFile = true;

                $("#FilesToUpload").hide();
                $(".k-button.k-upload-button").addClass("d-none");
                $(".UploadAttachmentPh img").hide();
            }



        },

        noRecordTemplate,
      //  getTooltipTilte: e => getTooltipTilte(e),
        getTooltipTilte: function (e) {
       
            let elem = e.target[0];
            if (((elem.offsetWidth < elem.scrollWidth) || elem.classList.contains('k-button'))) {
                $('[role="tooltip"]').css("visibility", "visible");
                if (elem.classList.contains("dimmedUnAuth")) {
                    return e.target.textContent = this.$i18n.t('Pharmacy.Unauthorized')
                }
                if (!elem.classList.contains("disabledClick")) {
                    return e.target.text();
                }
               

            }


            else {
                $('[role="tooltip"]').css("visibility", "hidden");
                return ""
            }
        },



        cancel: function () {
            this._bv__modal.hide('attachment');
            this.requiredFile = false;
            this.counter = 0;
            this.formData.nameFile = '';
            this.appearProgress = false;
            this.disabledImport = true;
            this.AttachmentsObj = {
                VisitId: null,
                PatientID: null,
                AttachmentTitle: null,
                AttachmentCategoryID: null,
                AttachmentScanLoad: null,
                AttachmentPath: null,
                IsUniqueTitle: true,
                IsValidAttachmentFileType: true,
                IsValidAttachmentFileSize: true,
                AttachmentFileError: null,
                files: [],
                AssignAttachToVisit: true,
                isVisitAttachement: false,
            };
            $("#progress").addClass("d-none");
        },

        async Scan() {
            if ($(".k-file-validation-message").length > 0) {
                this.fileValid = false;
            } else {
                this.fileValid = true;

            }

            if (this.formData.nameFile) this.requiredFile = false;
            else this.requiredFile = true;
            const isValid = await this.$refs.observer.validate();

            if (isValid && this.AttachmentCategoryDataSource && this.ScannersAvaliablesDataSource) {
                if (window.ws.readyState == WebSocket.OPEN) {
                    window.ws.send("Scan using:" + this.SelectedScanner);
                }
            }

        },
        UploadDateTemplate(dataItem) {
            var UploadDate = kendo.toString(kendo.parseDate(dataItem.UploadDate), 'dd/MM/yyyy');
            var UploadTime = kendo.toString(kendo.parseDate(dataItem.UploadDate), 'h:mm tt');
            if (this.isArabicLanguage) {

                UploadTime = this.FormateArabicDate(UploadTime);
            }
            return '<span class="mleft-3">' + UploadDate + ' ' + UploadTime + '</span>'
        },
        clear: function () {
            this.$refs.observer.reset();
            this.AttachmentsObj.AttachmentCategoryID = null;
            this.AttachmentsObj.AttachmentTitle = null;
            this.AttachmentsObj.files = [];
            this.AttachmentsObj.AttachmentCategoryID = null;
            this.AttachmentsObj.IsUniqueTitle = true;
            this.AttachmentsObj.AssignAttachToVisit = true;
            this.AttachmentsObj.IsScannedFile = true;

            this.SelectedScanner = "";
            $('.k-upload-action').click()
            this.requiredFile = false;
            this.$refs.observer.reset();

        },
        ChangeUpload() {
            this.requiredFile = false;

            this.$refs.observer.reset();

        },
        DataBoundPatientAttach: function (ev) {

         
           
            //$('.wrapperDimmedUnAuth').hover(
              
            //    function () {
            //        debugger
            //        let that = $(this);
            //        console.log('DimmedUnAuthDel', that.find(".DimmedUnAuthDel"))
            //      that.find(".DimmedUnAuthDel").show();
                  
            //    },
            //    function () {
            //        debugger
            //         that.find(".DimmedUnAuthDel").hide();
            //    }
            //);

            if (!this.PharmacyAssignAttachmentPermission) {
                $('.k-grid-assignRow').addClass('d-none')
            } else {
                $('.k-grid-assignRow').removeClass('d-none')
            }

            if (!this.PharmacyPrintAttachmentPermission) {
                $('.k-grid-printAttachmentRow').addClass('d-none')
            } else {
                $('.k-grid-printAttachmentRow').removeClass('d-none')
            }

            if (!this.PharmacyDeleteAttachmentPermission) {
                $('.k-grid-deletePatientAttach').addClass('d-none')
            } else {
                $('.k-grid-deletePatientAttach').removeClass('d-none')
            }

            if (!this.PharmacyDeleteAttachmentPermission) {
                $('.k-grid-deleterow').addClass('d-none')
            } else {
                $('.k-grid-deleterow').removeClass('d-none')
            }

            if (!this.PharmacyViewAttachmentPermission) {
                $('.k-grid-view').addClass('d-none')
            } else {
                $('.k-grid-view').removeClass('d-none')
            }
         
          //  this.userIdAttchm = localStorage.getItem('EmployeeID');
          //  console.log('localstorage', this.userIdAttchm)
            var data = ev.sender.dataSource._data;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                var uid = item.uid;
                var row = $("tr[data-uid='" + uid + "']");

                var td = row.find(".k-command-cell");
                var assing = td.find(".k-grid-assignRow");
                var DeleteAction = td.find(".k-grid-deleterow");

                if (item.IsAssignedToVisit) {
                    assing.attr('disabled', true);
                } else {
                    assing.attr('disabled', false);
                }
                if (item.CreatedBy != this.userIdAttchm) {
                    DeleteAction.addClass('dimmedUnAuth');
                } else {
                    DeleteAction.removeClass('dimmedUnAuth');
                }


            }
        },
        DataBoundVisitAttach: function () {
            if (!this.PharmacyInAssignAttachmentPermission || this.VisitAttachmentParameters.isViewOnly) {
                $('.k-grid-unassignRow').addClass('d-none')
            } else {
                $('.k-grid-unassignRow').removeClass('d-none')

            }

            if (!this.PharmacyPrintAttachmentPermission) {
                $('.k-grid-printAttachmentRow').addClass('d-none')
            } else {
                $('.k-grid-printAttachmentRow').removeClass('d-none')
            }

            if (!this.PharmacyViewAttachmentPermission) {
                $('.k-grid-view').addClass('d-none')
            } else {
                $('.k-grid-view').removeClass('d-none')
            }

        },
        showPopUp() {
            this.$refs['attachement-ref'].show();
        }
    },
    mounted() {
        $("body").addClass("custom-upload-file");
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();
        extend('required', {
            ...required,
            message: this.$i18n.t('Common.Required')
        });

        if (this.$parent.IsopenAttach || this.$parent.IsopenBannerAttach) {
            EventBus.$on('attachmentParameters', (data) => {
             

                this.AttachmentsObj = {
                    VisitId: null,
                    PatientID: null,
                    AttachmentTitle: null,
                    AttachmentCategoryID: null,
                    AttachmentScanLoad: null,
                    AttachmentPath: null,
                    IsUniqueTitle: true,
                    IsValidAttachmentFileType: true,
                    IsValidAttachmentFileSize: true,
                    AttachmentFileError: null,
                    files: [],
                    AssignAttachToVisit: true,
                    isVisitAttachement: false,
                    ModuleID: null,
                    OrderLineID: null,

                };
                this.formData.AttachType = this.UploadType;
                this.VisitAttachmentParameters = null;
                this.PatientAttachDS = {};
                this.VisitAttachmentParameters = data;
                this.AttachmentsObj.VisitId = sessionStorage.getItem("sessionVisitID")
                this.AttachmentsObj.PatientID = this.VisitAttachmentParameters.PatientID,
                    this.AttachmentsObj.OrderLineID = this.VisitAttachmentParameters.orderLineId,
                    this.AttachmentsObj.ModuleID = this.VisitAttachmentParameters.module,

                    this.initAttachmentModal();

            });

        }
                
    },
    beforeDestroy() {
        EventBus.$off("attachmentParameters");
        EventBus.$off("ReloadGrid");
    }
    ,
    components: {
        ConfirmDeletePopup,
        InAssginConfirmDeletePopup,
        AssginConfirmDeletePopup,
        Loader,
        ValidationProvider,
        ValidationObserver,
        showPopupNotification,
        Upload,
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
}